import Config from 'react-native-config';
import { StorageKey } from './types';

/**
 * Constant: encryptionSettings
 * Description: Encryption Settings for Crypto-js - used encrypting sensitive amwell information.
 */
export const encryptionSettings = {
  algorithm: 'aes-256-ctr',
  password: 'password'
};

/**
 * Constant: configuration
 * Description: Amwell environment sdk key and base url - used to initialize awsdk.
 */
export const configuration = {
  baseUrl: Config.AMWELL_URL,
  sdkApiKey: Config.AMWELL_KEY,
  locale: 'en_US',
  isIVRCallbackEnabled: true,
  launchTelehealthVideoClientTimeout: 10 * 60 * 1000
};

/**
 * Constant: sessionKeys
 * Description: Keys related to the Connect Care flow
 */
export const sessionKeys = [
  StorageKey.ACTIVE_CONSUMER,
  StorageKey.PRACTICE,
  StorageKey.PROVIDER,
  StorageKey.SPECIALTY,
  StorageKey.VISIT_CONTEXT,
  StorageKey.DISCLAIMERS_ACKNOWLEDGED,
  StorageKey.APPOINTMENT,
  StorageKey.VISIT,
  StorageKey.VISIT_SUMMARY
];

/**
 * Constant: allKeys
 * Description: All keys in amwell storage
 */
export const allKeys = [StorageKey.CONSUMER, StorageKey.AUTHENTICATION, ...sessionKeys];

/**
 * Constant: Errors
 * Description: General errors codes to use when matched with specific errorCodes from coming from the awsdk.
 */
export const errors = {
  WEBRTC_SUPPORT: 'This device does not support WebRTC',
  INTERNAL_ERROR: 'Internal Error',
  MISSING_PARAMETERS: 'Missing parameters',
  INCORRECT_PARAMETERS: 'Incorrect parameters',
  VALIDATION_ERROR: 'Validation error',
  INCORRECT_CREDENTIALS: 'Incorrect credentials',
  DEPENDENT_EXISTS: 'Registering dependent already exists',
  NOT_REGISTERED: 'Consumer needs to complete registration',
  NOT_AUTHENTICATED: 'Consumer is not authenticated',
  FIRST_UNAVAILABLE: 'No specialties available for first availability',
  CONSUMER_IN_VISIT: 'Consumer is already in a visit',
  DEPENDENT_NOT_FOUND: 'Dependent not found',
  PROVIDER_NOT_FOUND: 'Provider not found',
  PROVIDER_VIDEO: "Provider's video is not enabled",
  PROVIDER_LOCATION: 'Provider is not licensed for consumer location',
  NO_PAYMENT: 'No payment information was found for the consumer',
  CONSUMER_FEED: "Consumer's health plan is feed controlled",
  SESSION_EXPIRED: 'Authentication session expired',
  PAYMENT_ERROR: 'Credit card has been declined',
  VIDEO_FAILURE: 'Connection to the video server for current visit has failed',
  INCORRECT_KEY: 'Incorrect SDK API key',
  INVALID_COUPON: 'Invalid coupon code',
  PRIVACY_DISCLAIMER_MISSING: "Consumer's privacy policy disclaimer is missing",
  VERSION: 'Incompatible version',
  BASE: 'Could not complete the request',
  INVALID_SERVICE_KEY: 'Invalid service key',
  VISIT_SUMMARY_NOT_SENT: 'Visit summary could not be sent',
  PROVIDER_NOT_AVAILABLE:
    'The suggested provider is no longer available. Please search for another.',
  VISIT_SUMMARY_ERROR: 'Visit summary could not be sent',
  RATING_ERROR: 'Rating could not be added',
  ATTACHMENT_SIZE: 'The size of the file is larger than supported',
  MIME_TYPE: 'The type of the file is not supported',
  MEDICATION_SEARCH_TEXT_TOO_SHORT: 'The medication search text must be at least 3 characters.'
};
